<!-- KYMW7001 表紙・特集掲載商品選定画面（バイヤー） -->
<div class="contents-area">
  <!-- 検索条件 -->
  <div class="layout_balance">
    <div class="element-column">
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-text-with-catalog #txt_OrderCode [autofocus]="true" [required]="true" [tabindex]="0"
              forcedEnabledMode="true" [(ngModel)]="kymw7001Model.orderCode" width="100"
              (onChangedCatalogId)="kymw7001Model.catalogId = $event" 
              (ngModelChange)="eventOrderCode_CHANGEHandler()" [disabled]="!mode">
            </app-order-text-with-catalog>
          </div>
          
          <label class="list-input-title">媒体</label>
          <div class="list-input-content">
            <app-versatile-combo-box id="cmb_MediumType" [(ngModel)]="kymw7001Model.mediumType" 
              [listSource]="kymw7001Model.MediumList" valueField="Code" labelField="Name" [disabled]="!mode" 
              [required]="true" [tabindex]="0" [width]="200"[dspBothField]="true" [visible]="true" [blank]="true" 
              [autofocus]="false" forcedEnabledMode="true" (ngModelChange)="eventMediumType_CHANGEHandler()">
            </app-versatile-combo-box>
          </div>
        </div>
        
        <div class="column-list">
          <label class="list-input-title">企画回</label>
          <div class="list-input-content">
            <app-catalog-text-with-order #catalogId [autofocus]="true" [required]="true" [tabindex]="0"
              forcedEnabledMode="true" [(ngModel)]="kymw7001Model.catalogId" [width]="100"
              (onChangedOrderCode)="kymw7001Model.orderCode = $event" [disabled]="!mode">
            </app-catalog-text-with-order>
          </div>
          
          <label class="list-input-title">特集</label>
          <div class="list-input-content">
            <app-versatile-combo-box id="cmb_FeatureType" [(ngModel)]="kymw7001Model.featureCode"
              [listSource]="kymw7001Model.FeatureList"valueField="Code" labelField="Name" 
              [disabled]="!mode" [required]="false" [tabindex]="0" [width]="200" [dspBothField]="true" 
              [visible]="true" [blank]="true" [autofocus]="false" forcedEnabledMode="true"
              (ngModelChange)="eventFeatureType_CHANGEHandler()">
            </app-versatile-combo-box>
          </div>
        </div>
      </div>
      <button id="btn_Display" #btn_Display class="btn-secondary" forcedEnabledMode="true"
        [tabindex]="0" (click)="eventDisplay_CLICKHandler()">表示</button>
    </div>

    <div class="column-list">
      <label class="list-input-title">備考</label>
      <div class="list-input-content">
        <app-text-area class="text-label-normal" [height]="150" [width]="700" [disabled]="!mode || permission !== '2' || !featureMemoDisable" 
          [(ngModel)]="kymw7001Model.featureMemo" (ngModelChange)="eventFeatureMemo_CHANGEHandler()"
          [displayCountField]="false" [maxChars]="500" [restrict]="'[ -￮]'" [fullOnly]="true">
        </app-text-area>
      </div>
    </div>
  </div>

  <div class="element-column">
    <!-- 選定対象 -->
    <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true" [hidden]="mode">
      <wj-accordion-pane>
        <div>選定対象</div>
        <div>
          <div style="max-width:1610px; width:100%;">
            <wj-flex-grid id="dtg_SelectionTargetList" #dtg_SelectionTargetList 
                style="width:1590px; height:100px;" [itemsSource]="kymw7001Model.SelectionTargetList" 
                [isReadOnly]="true" overflow="auto" (scroll)="$event.stopPropagation()"
                [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
              <wj-flex-grid-column [header]="'特集'" [minWidth]="5" [width]="100" [binding]="'formatFeature'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'部門'" [minWidth]="5" [width]="100" [binding]="'formatClass'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'中分類'" [minWidth]="5" [width]="150" [binding]="'formatMiddleClass'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'Pコード'" [minWidth]="5" [width]="90" [binding]="'pCode'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'商品名'" [minWidth]="5" [width]="100" [binding]="'guideGoodsName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'規格名'" [minWidth]="5" [width]="100" [binding]="'guideStandardName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'価格パターン'" [minWidth]="5" [width]="100" [binding]="'pricePattern'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'今回供給価格'" [minWidth]="5" [width]="100" [binding]="'thisTimeSupplyPrice'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'仕入価'" [minWidth]="5" [width]="90" [binding]="'thisTimeCostPrice'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'計画数(予測)'" [minWidth]="5" [width]="100" [binding]="'predictPlanNum'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'計画数(修正)'" [minWidth]="5" [width]="100" [binding]="'planNum'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'計画供給高（千円）'" [minWidth]="5" [width]="143" [binding]="'dispPlanSupplyBudget'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'GPR'" [minWidth]="5" [width]="100" [binding]="'gpr'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'備考'" [minWidth]="5" [width]="197" [binding]="'remarks'">
              </wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>
      </wj-accordion-pane>
    </wj-accordion>

    <!-- 候補一覧 -->
    <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true" [hidden]="mode">
      <wj-accordion-pane>
        <div>候補一覧</div>
        <div>
          <div class="element-column" style="max-width:1610px;">
            <button id="btn_Search" #btn_Search class="btn-secondary"
              forcedEnableMode="" [tabindex]="0" (click)="eventSeach_CLICKHandler()">商品検索</button>
            <wj-flex-grid #dtg_TargetList id="dtg_TargetList" [itemsSource]="kymw7001Model.TargetListInfo"
              [isReadOnly]="true" style="width: 1590px; height:160px;"
              [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
              <wj-flex-grid-column [minWidth]="5" [width]="40" [binding]="''" [header]="' '" [align]="'center'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div>
                    <input type="checkbox" [tabindex]="-1" (mouseup)="$event.stopPropagation()" [(ngModel)]="cell.item.check" 
                      id="target_list_check_{{cell.row.index}}" [disabled]="cell.item.checkFlag"/>
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'Pコード'" [minWidth]="5" [width]="120" [binding]="'pCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [header]="'商品名'" [minWidth]="5" [width]="225" [binding]="'guideGoodsName'"></wj-flex-grid-column>
              <wj-flex-grid-column [header]="'規格名'" [minWidth]="5" [width]="175" [binding]="'guideStandardName'"></wj-flex-grid-column>
              <wj-flex-grid-column [header]="'部門'" [minWidth]="5" [width]="200" [binding]="'formatClass'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'大分類'" [minWidth]="5" [width]="200" [binding]="'formatLargeClass'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'中分類'" [minWidth]="5" [width]="200" [binding]="'formatMiddleClass'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'小分類'" [minWidth]="5" [width]="200" [binding]="'formatSmallClass'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'タグ'" [minWidth]="5" [width]="210" [binding]="'tagName'"></wj-flex-grid-column>
            </wj-flex-grid>
            <button id="btn_Selection" #btn_Selection class="btn-secondary" 
              forcedEnableMode="" [tabindex]="0" (click)="eventSelection_CLICKHandler()">選定</button>
          </div>  
        </div>
      </wj-accordion-pane>
    </wj-accordion>

    <!-- 選定商品一覧 -->
    <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true">
      <wj-accordion-pane>
        <div>選定商品一覧</div>
        <div>
          <div class="element-column" style="max-width:1610px; width:100%;">
            <wj-flex-grid id="dtg_SelectionGoodsList" #dtg_SelectionGoodsList class="select-target-list" 
                [ngClass]="mode ? 'confirm-selection-list' : 'select-selection-list'"
                [itemsSource]="kymw7001Model.SelectionList" [isReadOnly]="true" (scroll)="$event.stopPropagation()"
                [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
              <wj-flex-grid-column [minWidth]="5" [minWidth]="5" [width]="40" [binding]="''" [header]="' '" *ngIf = "mode" [align]="'center'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div>
                    <input type="checkbox" [tabindex]="-1" (mouseup)="$event.stopPropagation()" 
                      [disabled]="permission !== '2'"
                      [(ngModel)]="cell.item.check" id="selection_goods_list_check_{{cell.row.index}}"
                      (change)="eventSelectionListChk_CLICKHandler()"/>
                  </div>
                </ng-template>
                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                  <div class="all-selection_list-checkbox">
                    <input type="checkbox" id="chk_All" #chk_All forcedEnabledMode="true" [tabindex]="0"
                      [disabled]="permission !== '2'"
                      (change)="eventSelectionListAll_CLICKHandler()" [(ngModel)]="kymw7001Model.selectionListAll"
                      class="headear-checkbox all-selection_list-checkbox"> 
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'特集'" [minWidth]="5" [width]="100" [binding]="'formatFeature'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'部門'" [minWidth]="5" [width]="100" [binding]="'formatClass'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'中分類'" [minWidth]="5" [width]="150" [binding]="'formatMiddleClass'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'Pコード'" [minWidth]="5" [width]="90" [binding]="'pCode'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'商品名'" [minWidth]="5" [width]="100" [binding]="'guideGoodsName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'規格名'" [minWidth]="5" [width]="100" [binding]="'guideStandardName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'価格パターン'" [minWidth]="5" [width]="100" [binding]="'pricePattern'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div style="width: 100%; height: 25px;">
                    <app-versatile-combo-box id="cmb_PricePettern" [(ngModel)]="cell.item.pricePattern"
                      [listSource]="kymw7001Model.PricePetternList" valueField="CodeValue" labelField="CodeName" 
                      [required]="true" [tabindex]="0" [visible]="true" [blank]="true" 
                      [autofocus]="false" forcedEnabledMode="true" (change)="eventPricePettern_CHANGEHandler(cell.item)"
                      [disabled]="permission !== '2'">
                    </app-versatile-combo-box>
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'今回供給価格'" [minWidth]="5" [width]="100" [binding]="'thisTimeSupplyPrice'" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div>
                    <input type="text" class="text-label-required" style="width: 100%; text-align: right;" 
                      [(ngModel)]="cell.item.thisTimeSupplyPrice" [restrict]="'[0-9]'" [halfOnly]="true" [maxlength]="7" plessInputTextSub
                      (change)="eventThisTimeSupplyPrice_CHANGEHandler(cell.item)" 
                      [disabled]="permission !== '2'">
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'仕入価'" [minWidth]="5" [width]="90" [binding]="'thisTimeCostPrice'" [align]="'right'">
                <div>
                  <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                    <input type="text" class="text-label-required" style="width: 100%; text-align: right;" 
                      [(ngModel)]="cell.item.thisTimeCostPrice" [restrict]="'[.0-9]'" [halfOnly]="true" [maxlength]="10" plessInputTextSub
                      (change)="eventThisTimeCostPrice_CHANGEHandler(cell.item)"
                      [disabled]="permission !== '2'">
                  </ng-template>
                </div>
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'計画数(予測)'" [minWidth]="5" [width]="100" [binding]="'predictPlanNum'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'計画数(修正)'" [minWidth]="5" [width]="100" [binding]="'planNum'" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div>
                    <input type="text" style="width: 100%; text-align: right;" [(ngModel)]="cell.item.planNum"
                      (change)="eventPlanNum_CHANGEHandler(cell.item)" [disabled]="permission !== '2'"
                      [restrict]="'[0-9]'" [halfOnly]="true" [maxlength]="8" plessInputTextSub [class.text-label-required]="cell.item.predictPlanNum === '' && mode">
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'計画供給高（千円）'" [minWidth]="5" [width]="143" [binding]="'dispPlanSupplyBudget'" *ngIf = "mode" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'計画供給高'" [minWidth]="5" [width]="100" [binding]="'planSupplyBudget'" *ngIf = "!mode" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div>
                    <input type="text" class="text-label-required" style="width: 100%; text-align: right;" 
                      [(ngModel)]="cell.item.planSupplyBudget" [disabled]="permission !== '2'"
                      (change)="eventPlanSupplyBudget_CHANGEHandler(cell.item)"
                      [restrict]="'[0-9]'" [halfOnly]="true" [maxlength]="11" plessInputTextSub>
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'GPR'" [minWidth]="5" [width]="100" [binding]="'gpr'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'タグ'" [minWidth]="5" [width]="100" [binding]="'tagName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'備考'" [minWidth]="5" [width]="140" [binding]="'remarks'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell" *ngIf = "!mode">
                  <div>
                    <input type="text" style="width: 100%;" [(ngModel)]="cell.item.remarks" [disabled]="permission !== '2'"
                    [restrict]="'[ -￮]'" [maxlength]="100" plessInputTextSub>
                  </div>
                </ng-template>
              </wj-flex-grid-column>
            </wj-flex-grid>
  
            <div class="layout_balance" *ngIf = "mode">
              <button id="btn_Add" #btn_Add class="btn-tartiary" style="width: 150px;" 
                forcedEnableMode=""
                [tabindex]="0" (click)="eventRejection_CLICKHandler()">却下</button>
              <button id="btn_Delete" #btn_Delete class="btn-secondary" style="width: 150px;" 
                forcedEnableMode=""
                [tabindex]="0" (click)="eventApproval_CLICKHandler()">承認</button>
            </div>
            <div class="layout_balance" *ngIf = "!mode">
              <button id="btn_SelectionCannel" #btn_SelectionCannel class="btn-tartiary"  style="width: 150px;" 
                forcedEnableMode="" [tabindex]="0" (click)="eventSelectionCannel_CLICKHandler()">選定解除</button>
              <button id="btn_Confirm" #btn_Confirm class="btn-secondary" style="width: 150px;"
                forcedEnableMode="" [tabindex]="0" (click)="eventConfirm_CLICKHandler()">確定</button>
            </div>
          </div>  
        </div>
      </wj-accordion-pane>
    </wj-accordion>

    <!-- 差し替え対象一覧 -->
    <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true" [hidden]="!mode">
      <wj-accordion-pane>
        <div>差し替え対象一覧</div>
        <div>
          <div style="max-width:1610px; width:100%; height: 160px;">
            <wj-flex-grid id="dtg_ReplacementList" #dtg_ReplacementList 
                style="width:1590px; height:160px;" [itemsSource]="kymw7001Model.ReplacementList"
                [isReadOnly]="true" overflow="auto" (scroll)="$event.stopPropagation()"
                [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
              <wj-flex-grid-column [header]="'依頼先バイヤー'" [minWidth]="5" [width]="120" [binding]="'requestBuyer'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <div style="width: 100%; height: 25px;" *ngIf="cell.item.requestStatus === '未依頼'">
                    <app-versatile-combo-box id="cmb_RequestBuyer" [(ngModel)]="cell.item.requestBuyer"
                      [listSource]="kymw7001Model.BuyreCodeList" valueField="CodeValue" labelField="CodeName" 
                      [required]="true" [tabindex]="0" [visible]="true" 
                      [blank]="true" [autofocus]="false" forcedEnabledMode="true" [disabled]="permission !== '2'"
                      (ngModelChange)="eventRequestBuyer_CHANGEHandler(cell.item)">
                    </app-versatile-combo-box>
                  </div>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'担当'" [minWidth]="5" [width]="90" [binding]="'person'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'特集'" [minWidth]="5" [width]="100" [binding]="'formatFeature'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'部門'" [minWidth]="5" [width]="100" [binding]="'formatClass'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'中分類'" [minWidth]="5" [width]="150" [binding]="'formatMiddleClass'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'Pコード'" [minWidth]="5" [width]="90" [binding]="'pCode'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'商品名'" [minWidth]="5" [width]="100" [binding]="'guideGoodsName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'規格名'" [minWidth]="5" [width]="100" [binding]="'guideStandardName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'価格パターン'" [minWidth]="5" [width]="100" [binding]="'pricePattern'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'今回供給価格'" [minWidth]="5" [width]="100" [binding]="'thisTimeSupplyPrice'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'仕入価'" [minWidth]="5" [width]="90" [binding]="'col1'" [binding]="'thisTimeCostPrice'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'計画数(予測)'" [minWidth]="5" [width]="100" [binding]="'predictPlanNum'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'計画数(修正)'" [minWidth]="5" [width]="100" [binding]="'planNum'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'計画供給高（千円）'" [minWidth]="5" [width]="143" [binding]="'dispPlanSupplyBudget'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'GPR'" [minWidth]="5" [width]="100" [binding]="'gpr'" [align]="'right'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'備考'" [minWidth]="5" [width]="100" [binding]="'remarks'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [header]="'ステータス'" [minWidth]="5" [width]="100" [binding]="'requestStatus'">
              </wj-flex-grid-column>
            </wj-flex-grid>
          </div>  
        </div>
      </wj-accordion-pane>
    </wj-accordion>
    
  </div>
</div>